import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import textLogo from "@/assets/images/text.png";
import { AnimatedThemeToggler } from "@/components/ui/animated-theme-toggler";
import { Button } from "@/components/ui/button";
import { m } from "@/paraglide/messages.js";

/**
 * The hosted pages' slim top bar: the wordmark (small, linking home) and a quiet way back to
 * the portfolio. Without it the archive is a dead end for anyone landing from a shared issue.
 */
export function ArchiveHeader() {
  return (
    <header className="mb-10 flex w-full items-center justify-between gap-4">
      <Link to="/" className="inline-flex items-center opacity-90 transition-opacity hover:opacity-100">
        <img src={textLogo} alt={m.app_title()} className="h-5 w-auto dark:invert" />
      </Link>
      <div className="flex items-center gap-2">
        <AnimatedThemeToggler className="text-muted-foreground hover:text-foreground size-9" />
        <Button variant="outline" size="sm" className="gap-1.5" asChild>
          <Link to="/">
            <ArrowLeft className="size-3.5" />
            {m.newsletter_archive_back_to_app()}
          </Link>
        </Button>
      </div>
    </header>
  );
}
